//
// TooltipOptionsController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/models/datagrid/CellVisualType";
import "../../models/common/NestedElementPosition";

var TooltipOptionsController = createModule("BIRD_TooltipOptionsController", [40468], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        supportsCellVisuals: [2],
        setCellVisualGradientEndColor: [0,10],
        unfreezeAllColumns: [0],
        columnIsFrozen: [2],
        freezeColumnsToLeft: [0],
        getCellVisualGradientEndColor: [10],
        getCellVisualType: [4],
        setCellVisualColor: [0,10],
        setCellVisualPosition: [0,4],
        getCellVisualColor: [10],
        setCellVisualType: [0,4],
        supportsTotal: [2,4,4],
        setTotalVisible: [0,4,4,2],
        setCellVisualGradientStartColor: [0,10],
        supportsFreezingColumns: [2],
        getCellVisualGradientStartColor: [10],
        getCellVisualPosition: [4],
        supportsCompactFormat: [2],
        columnIsUsingCompactFormat: [2],
        setCompactFormat: [0,2],
        isTotalVisible: [2,4,4],
    },
    ,
    ,
]);
export default TooltipOptionsController;
